
import ClientHead from "@/components/main/core/ClientHead";
import RedSection from "@/components/main/core/RedSection";
import CheckBox from "@/components/main/core/CheckBox";

export default {
  head() {
    const title = 'GDPR Compliance - Protecting Your Personal Data | iFindCheaters';
    const description = 'Learn how iFindCheaters complies with GDPR regulations to ensure the security and privacy of your personal data. Understand your rights and our commitment to data protection.';

    return {
      title: title,
      meta: [
      {
          hid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          hid: 'description',
          name: 'description',
          content: description
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'Personal Data Security, Privacy Policy Compliance, GDPR Compliance, Terms and Condition, How to use iFindCheaters, Guidelines to use cheater lookup app'
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: title
        }
      ],
      link: [
        {
          hid: "canonical",
          rel: "canonical",
          href: "https://ifindcheaters.com/gdpr/",
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "iFindCheaters",
              "item": "https://ifindcheaters.com/"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "General Data Protection Regulation (GDPR)",
            }],
          }
        }
      ]
    };
  },

  name: "gdpr",
  layout: 'clientLayout',
  mixins: [],
  components: {ClientHead, RedSection, CheckBox,},
  data() {
    return {

    }
  },
  computed: {

  },
  mounted() {
  },
  methods: {}
}
